module.exports = __webpack_public_path__ + "img/globe_red.4386451c.svg";